import React, { useState } from 'react';

// Small ⓘ icon with a hover/tap tooltip for explaining jargon in-place.
// Usage: <InfoDot>Front of House: servers, bartenders, hosts, bussers, managers.</InfoDot>
export default function InfoDot({ children, size = 13, color = '#9CA3AF' }) {
  const [open, setOpen] = useState(false);
  return (
    <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onClick={(e) => { e.stopPropagation(); setOpen(v => !v); }}>
      <span
        style={{
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          width: size, height: size, borderRadius: '50%',
          border: `1px solid ${color}`, color,
          fontSize: Math.round(size * 0.7), fontWeight: 700, fontStyle: 'italic',
          fontFamily: 'Georgia, serif', lineHeight: 1, cursor: 'help',
          background: 'transparent', userSelect: 'none',
        }}
        aria-label="More info"
      >i</span>
      {open && (
        <span
          onClick={e => e.stopPropagation()}
          style={{
            position: 'absolute', top: '100%', left: '50%', transform: 'translateX(-50%)',
            marginTop: 6, zIndex: 60,
            background: '#1F2937', color: '#F9FAFB',
            padding: '6px 10px', borderRadius: 6, fontSize: 11, lineHeight: 1.4,
            width: 'max-content', maxWidth: 260, textAlign: 'left',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            pointerEvents: 'auto', fontWeight: 400, letterSpacing: 0, textTransform: 'none',
          }}
        >
          {children}
        </span>
      )}
    </span>
  );
}
